import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQ } from "../data/eventData";
import { MaskLine, Reveal } from "./Motion";

export default function Faq() {
  return (
    <section id="faq" className="relative py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="mb-12">
          <h2 className="heading-lg" data-testid="faq-heading">
            <MaskLine inView>Tudo o que você</MaskLine>
            <MaskLine inView delay={0.12}>
              <span className="text-gradient-blue">precisa saber.</span>
            </MaskLine>
          </h2>
        </div>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQ.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display font-semibold text-base sm:text-lg text-white hover:text-white/70 hover:no-underline py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-brand-silver/75 leading-relaxed text-sm sm:text-base pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
